import { Dom } from './dom'

export class Dropdown {
  constructor() {
    this.dom = new Dom()
    this.dropdowns = []
  }

  mount = () => {
    this.dropdowns = this.dom.allDropdowns

    this.initClickHandlers()
  }

  initClickHandlers = () => {
    this.dropdowns.forEach(dropdown => dropdown.addEventListener('click', this.toggleDropdown))
    window.addEventListener('click', this.removeActiveDropdowns)
  }

  removeActiveDropdowns = e => {
    const { target } = e

    if (this.dom.isOutsideDropdown(target)) {
      this.dom.inactivateAllActiveDropdowns()
    }
  }

  toggleDropdown = e => {
    const { target } = e

    if (this.dom.isActive(target)) {
      this.dom.inactivate(target)
    } else {
      this.dom.inactivateAllActiveDropdowns()
      this.dom.activate(target)
    }
  }
}
